import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'clever-menu2-subitem',
    templateUrl: './menu2-subitem.component.html',
    styleUrls: ['./menu2-subitem.component.scss'],
    standalone: false
})
export class Menu2SubitemComponent {
    @Input() column: any;
    @Input() editmode: boolean;
    @Input() deskmode: string;
    @Output() removecolumn: EventEmitter<boolean> = new EventEmitter<boolean>();

    animationState = 'out';
}
